export const VIEW_AS_ROLE_STORAGE_KEY = 'view_as_role_name'
export const VIEW_AS_ROLE_TRANSLATED_STORAGE_KEY = 'view_as_role_translated'

export function getStoredViewAsRole() {
  return sessionStorage.getItem(VIEW_AS_ROLE_STORAGE_KEY) || null
}

export function getStoredViewAsRoleTranslated() {
  return sessionStorage.getItem(VIEW_AS_ROLE_TRANSLATED_STORAGE_KEY) || null
}

export function setStoredViewAsRole(roleName, roleTranslated = null) {
  if (roleName) {
    sessionStorage.setItem(VIEW_AS_ROLE_STORAGE_KEY, roleName)
    if (roleTranslated) {
      sessionStorage.setItem(VIEW_AS_ROLE_TRANSLATED_STORAGE_KEY, roleTranslated)
    } else {
      sessionStorage.removeItem(VIEW_AS_ROLE_TRANSLATED_STORAGE_KEY)
    }
  } else {
    sessionStorage.removeItem(VIEW_AS_ROLE_STORAGE_KEY)
    sessionStorage.removeItem(VIEW_AS_ROLE_TRANSLATED_STORAGE_KEY)
  }
}

export function viewAsRoleHeaderValue() {
  return getStoredViewAsRole()
}
